import { Action } from 'redux-saga'

export type BaseInitialState<T extends unknown> = {
  data: T
  loading: boolean
  error: boolean
}

export type ReduxSagaAction<ActionPayload extends any = any> = Action & {
  payload: ActionPayload
}

export enum REDUX_REQUEST_TYPES {
  REQUEST = 'REQUEST',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
